// extracted by mini-css-extract-plugin
module.exports = {"prev":"Arrows_prev__xWjQt","next":"Arrows_next__1xJDa"};